<template>
    <el-select  @change="change" v-model="vModel"
                filterable clearable
                :placeholder="placeholder"
                :remote="remote"
                :remote-method="remoteMethod"
                :multiple = "multiple"
                :allow-create="allowCreate"
                :disabled="disabled" :class="customClass">
        <el-option
                v-for="item in options"
                :key="item[valueKey || 'FID']"
                :label="item[labelKey || 'FID']"
                :value="item[valueKey || 'FName']"
                :disabled="item.disabled">
        </el-option>
    </el-select>
</template>

<script>
    import util from '../common/util'
    import Vue from 'vue'
    export default {
        props:{
            optionData:null,
            value:null,
            multiple:{
                type:Boolean,
                default:false
            },
            labelKey:{
                type:String,
                default:"FName"
            },
            valueKey:{
                type:String,
                default:"FID"
            },
            jsonKey:{
                type:String,
                default:"options"
            },
            customClass:{
                type:String,
                default:"myClass"
            },
            placeholder:{
                type:String,
                default:"请选择"
            },
            disabled:{
                type:Boolean,
                default:false
            },
            remote:{
                type:Boolean,
                default:false
            },
            allowCreate:{
                type:Boolean,
                default:false
            },
            //当value为0或者不存在下拉值时，界面是否显示value值。否则显示空
            noMatchValue:{
                type:String,
                default:"0"
            },
            //extendData是比较变态的参数，保存控件的状态数据，
            // 以便change中传出去,在动态组件中使用到。比如BaseList.vue的searchChange
            //TODO：这里难以理解，是不是需要重构？
            extendData:null
        },
        data() {
            return {
                vModel:this.value,
                options:[],
                loaded:false
            };
        },
        //mounted初始化之前，watch是不会触发的
        watch:{
            value(val){
                this.vModel = val
                if (val !== null) {
                    this.dealNoMatch()
                }
            },
            vModel(val){
                this.$emit("input", val)
            },
            //动态可以改变数据
            optionData(val){
                //初始化之前，watch是不会触发的
                //this.vModel = null;  //为什么？  因为切换记录时？
                this.fillData(val)
            }
        },
        methods:{
            remoteMethod(query){
                if(this.remote && this.loaded){
                    //手动输入
                    let url = this.optionData + "&" + this.labelKey + "=" + (query?query:"")
                    this.fillData(url)
                }
            },
            change(val){
                if(this.multiple){
                    //查找 record
                    let records = [];
                    let label = []
                    for(let item of this.options){
                        if(val.indexOf(item[this.valueKey])>=0){
                            records.push(item)
                            label.push(item[this.labelKey])
                        }
                    }
                    this.$emit("change",val,label.join(","),records,this.extendData)
                }else{
                    //查找 record
                    let record = {};
                    for(let item of this.options){
                        if(item[this.valueKey]==val){
                            record = item
                            break
                        }
                    }
                    this.$emit("change",val,record,this.extendData)
                }
            },
            fillData(val,callback){
                if(!val){
                    return
                }
                if(typeof(val)=="string"){
                    //url模式, 带{0}表示远程搜索,初始值要为空值
                    util.get(val, {}, null, result => {
                        this.options = result[this.jsonKey]
                        if(callback){
                            callback()
                        }
                    })
                }else {
                    this.options=[]
                    //对象、二维数组、一维数组
                    for(let item of val){
                        if(item.constructor==Array){
                            let value = {}
                            value[this.valueKey] = item[0]
                            value[this.labelKey] = item[1]
                            this.options.push(value)
                        }else if(item.constructor==String){
                            let value = {}
                            value[this.valueKey] = item
                            value[this.labelKey] = item
                            this.options.push(value)
                        }else{ //object
                            this.options.push(item)
                        }
                    }
                    if(callback){
                        callback()
                    }
                }
            },
            dealNoMatch(){
                //下拉框列表没有数据匹配的时候，会显示FID。
                // 正常来说应该是显示空
                if (this.vModel==this.noMatchValue) {
                    this.vModel = null
                }
            }
        },
        mounted() {
            if(this.remote){
                this.dealNoMatch()
                //编辑的时候，下拉框因为没有值，会显示FID,此时先不让它显现，等到从服务器取好数了再显示
                let tempValue = this.vModel
                this.vModel = null
                let url = this.optionData + "&" + this.valueKey + "=" + (tempValue?tempValue:"")
                this.fillData(url,()=>{
                    this.vModel = tempValue
                    Vue.nextTick(()=>{
                        this.loaded = true
                    })
                })
            }else {
                this.dealNoMatch()
                //编辑的时候，下拉框因为没有值，会显示FID,此时先不让它显现，等到从服务器取好数了再显示
                let tempValue = this.vModel
                this.vModel = null
                this.fillData(this.optionData,()=>{
                    this.vModel = tempValue
                    Vue.nextTick(()=>{
                        this.loaded = true
                    })
                })
            }
        }
    }
</script>

<style scoped>
    .myClass{
        width: 100%
    }
</style>



// WEBPACK FOOTER //
// src/components/Select.vue